<app-header [forceLightBackground]="true"></app-header>
<div class="org-admin-mdm">
  <div class="org-admin-mdm--layout">
    <app-org-admin-sidebar class="org-admin-mdm--sidebar"></app-org-admin-sidebar>
    <div class="org-admin-mdm--content">
      <app-page-header></app-page-header>
      <div class="mdm-container">
        <!-- Content will be added here -->
      </div>
    </div>
  </div>
</div>



